"use strict";

exports.__esModule = true;
exports.DeviceCollectionContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a collection of devices to consumers.
 * @component
 */
var DeviceCollectionContext = exports.DeviceCollectionContext = (0, _Utils.createEnhancedContext)({
  propName: "deviceCollection"
});